module.exports = __webpack_public_path__ + "img/room08_clipboard_mini.42c3e27e.png";